import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getModel } from './selectors';
import * as actions from './actions';
import EventLogsComponent from './EventLogsComponent';


const EventLogsContainer = (props) => {
	return <EventLogsComponent {...props} />;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return {
		model
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators(actions, dispatch)
	};
};

const EventLogsContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(EventLogsContainer);


export default EventLogsContainerConn;
